import React, { Component } from "react";
import {
  Scroll,
  Wrapper,
  Button,
  Icon,
  ProfilePic,
  Row,
  Copy,
  Card,
  Bold,
  Spin
} from "app/NativeComponents/common";

class Responses extends Component {
  handleSelection(response_text) {
    var comment = this.props.message.slice(
      0,
      this.props.message.length - this.props.mention_keyword.length
    );
    this.props.updateMessageProp({
      prop: "message",
      value: response_text
    });
    this.props.updateMessageProp({ prop: "show_save_reply", value: false });

    this.props.updateMessageProp({ prop: "mention_keyword", value: "" });
    this.props.updateMessageProp({ prop: "mention_prev_char", value: " " });
    this.props.updateMessageProp({ prop: "mention_tracker", value: false });
  }

  filterData() {
    //const max_limit = 2;
    const responses_array = this.props.saved_responses;
    var output_array = [];
    if (this.props.mention_tracker) {
      if (responses_array.length > 0) {
        for (var i = 0; i < responses_array.length; i++) {
          const response = responses_array[i];
          const keyword = this.props.mention_keyword.replace("#", "");
          if (
            response.response_text
              .toLowerCase()
              .startsWith(keyword.toLowerCase())
          ) {
            output_array.push(response);
          }
        }
      }
    }
    return output_array;
  }

  renderEditButtons(item) {
    if (!item.global_response && !this.props.multisend) {
      return (
        <Row>
          <Button
            style={{
              width: 50,
              height: 50,
              alignItems: "center",
              justifyContent: "center"
            }}
            onPress={() => {
              this.props.setEditModal({
                title: "Edit Saved Reply",
                description: "Edit reply to be used in other conversations.",
                slug: "edit-saved-reply",
                type: "edit_saved_reply",
                fields: {
                  response_text: item.response_text,
                  starting_response: item.starting_response ? 1 : 0
                },
                save_button_text: "Edit Saved Reply",
                modalAction: ({ fields }) => {
                  this.props.updateSavedResponse({
                    token: this.props.token,
                    type: "update_saved_response",
                    saved_response_id: item.id,
                    response_text: fields.response_text,
                    starting_response: fields.starting_response,
                    onSuccess: () => {
                      this.props.appRedirect({
                        redirect: "goBack",
                        payload: { remove: "edit-saved-reply" }
                      });
                    }
                  });
                },
                cancelAction: () => {},
                fieldsUpdated: fields => {}
              });
              this.props.appRedirect({
                redirect: "goForward",
                payload: { add: "edit-saved-reply" }
              });
            }}
          >
            <Icon
              icon="edit"
              size={18}
              color={this.props.colors.light_text_color}
              style={{
                marginRight: 5
              }}
            />
          </Button>

          <Button
            style={{
              width: 50,
              height: 50,
              alignItems: "center",
              justifyContent: "center"
            }}
            onPress={() => {
              this.props.setModal({
                title: "Remove saved reply?",
                description:
                  "Are you sure you want to remove this saved reply?",
                icon: "",
                submit: "Remove",
                buttonType: "destroy",
                onPress: () => {
                  this.props.updateSavedResponse({
                    token: this.props.token,
                    type: "remove_saved_response",
                    saved_response_id: item.id,
                    onSuccess: () => {}
                  });
                },
                cancel: "Cancel",
                onCancel: () => {}
              });
              this.props.toggleModal({ show: true, type: "normal" });
            }}
          >
            <Icon
              icon="delete"
              size={18}
              color={this.props.colors.light_text_color}
            />
          </Button>
        </Row>
      );
    }
  }

  renderSpamLabel(saved_reply) {
    const { colors } = this.props;
    if (
      saved_reply.spam &&
      saved_reply.starting_response &&
      !saved_reply.spam.valid &&
      saved_reply.spam.phrases &&
      saved_reply.spam.phrases.length > 0
    ) {
      let spam_phrases = "";
      for (let i = 0; i < saved_reply.spam.phrases.length; i++) {
        if (spam_phrases.length == 0) {
          spam_phrases += saved_reply.spam.phrases[i];
        } else {
          spam_phrases += "," + saved_reply.spam.phrases[i];
        }
      }
      return (
        <Row>
          <Wrapper
            style={{
              backgroundColor: colors.yellow_card_color_muted,
              borderRadius: 15,
              padding: 3,
              paddingLeft: 10,
              paddingRight: 10,
              marginTop: 5
            }}
          >
            <Copy>Flagged As Spam (Remove the following: {spam_phrases})</Copy>
          </Wrapper>
        </Row>
      );
    }
  }

  render() {
    if (this.props.saved_responses_loading && this.props.mention_tracker) {
      return (
        <Wrapper
          style={{
            maxHeight: 50,
            margin: 10,
            borderRadius: 5,
            borderColor: this.props.colors.border_color,
            borderWidth: 1,
            borderStyle: "solid",
            backgroundColor: this.props.colors.card_color
          }}
        >
          <Row style={{ padding: 10 }}>
            <Spin size="small" />
            <Copy style={{ marginLeft: 10 }}>Loading Responses...</Copy>
          </Row>
        </Wrapper>
      );
    }

    if (this.props.mention_tracker && this.filterData().length > 0) {
      return (
        <Scroll
          style={{
            maxHeight: 125,
            margin: 10,
            borderRadius: 5,
            borderColor: this.props.colors.border_color,
            borderWidth: 1,
            borderStyle: "solid",
            backgroundColor: this.props.colors.card_color
          }}
          keyboardShouldPersistTaps={"always"}
        >
          {this.filterData().map((item, i) => {
            return (
              <Wrapper
                key={i}
                style={{
                  width: "100%"
                }}
              >
                <Button
                  style={{ flex: 1 }}
                  onPress={() => this.handleSelection(item.response_text)}
                >
                  <Card>
                    <Row>
                      <Wrapper style={{ flex: 1 }}>
                        <Wrapper style={{ padding: 10 }}>
                          <Copy>{item.response_text}</Copy>
                          {this.renderSpamLabel(item)}
                        </Wrapper>
                      </Wrapper>
                      {this.renderEditButtons(item)}
                    </Row>
                  </Card>
                </Button>
              </Wrapper>
            );
          })}
        </Scroll>
      );
    }
    return <Wrapper />;
  }
}

export default Responses;
